<div class="content">
  <div class="content-panel">
    <h2>
      <span *ngIf="edition == false" translate>page.commissions.edit.titleCreer</span>
      <span *ngIf="edition == true" translate>page.commissions.edit.titleEditer</span>
      <span class="chiffres">
        <fa-icon icon="clipboard-list" title="{{'page.commissions.edit.tooltip.cdcs'|translate}}"></fa-icon>{{nbCdcs}} -
        <fa-icon icon="user-plus" title="{{'page.commissions.edit.tooltip.jures_incrits'|translate}}"></fa-icon>
        {{nbJuresInscrits}} -
        <fa-icon icon="user-check" title="{{'page.commissions.edit.tooltip.jures_presents'|translate}}"></fa-icon>
        {{nbJuresPresents}} -
        <fa-icon icon="users" title="{{'page.commissions.edit.tooltip.jures_total'|translate}}"></fa-icon>
        {{nbJuresTotal}} -
        <fa-icon icon="wine-glass-alt" title="{{'page.commissions.edit.tooltip.echantillons'|translate}}"></fa-icon>
        {{nbEchantillons}}
        <span *ngIf="edition == true">
          <label class="form-label" translate style="font-size: 20px; padding-right: 10px; padding-left: 50px;">Terminée</label>
          <input type="checkbox" (change)="checkValue(commissionIsOver? true:false)" [(ngModel)]="commissionIsOver" />
        </span>

      </span>
      <div *ngIf="edition == true">
        <span>
          <button style="position:relative;" type="button" class="btn btn-primary" (click)="telechargerDocument()" translate>
            page.commissions.edit.telechargerDocuments
          </button>
          <button style="position:relative;margin-left: 1em;" type="button" class="btn btn-primary" (click)="envoyerDocumentsMail()" translate>
            page.commissions.edit.envoyerDocumentsMail
          </button>
          <button style="position:relative;margin-left: 1em;" type="button" class="btn btn-primary" (click)="goToExporterEchantillons()" translate>
            page.commissions.edit.exporterEchantillons
          </button>
          <button style="position:relative;margin-left: 1em;" type="button" class="btn btn-primary" (click)="goToResultatCommission()" translate>
            page.commissions.edit.resultat-commission
          </button>
        </span>
      </div>

    </h2>

    <form *ngIf="formGroup" [formGroup]="formGroup" #form="ngForm" (ngSubmit)="submit()" novalidate>

      <div class="form-section">
        <div class="mb-3">
          <label class="form-label" translate>page.commissions.edit.date</label>

          <div class="input-group">
            <input formControlName="date" ngbDatepicker #datePicker="ngbDatepicker"
              [ngClass]="{'is-invalid': form.submitted && formGroup.get('date').invalid}" class="form-control" />
            <button type="button" (click)="datePicker.toggle()" class="btn btn-secondary">
              <fa-icon icon="calendar-alt"></fa-icon>
            </button>
          </div>
        </div>

        <div class="mb-3">
          <label class="form-label" translate>page.commissions.edit.annee</label>
          <input type="text" formControlName="annee" [ngClass]="{'is-invalid': form.submitted && formGroup.get('annee').invalid}" class="form-control input-text"/>
        </div>

        <div class="mb-3">
          <label class="form-label" translate>page.commissions.edit.heureDebut</label>
          <ngb-timepicker formControlName="heureDebut"
            [ngClass]="{'is-invalid': form.submitted && formGroup.get('heureDebut').invalid}" class="form-control">
          </ngb-timepicker>
        </div>

        <div class="mb-3">
          <label class="form-label" translate>page.commissions.edit.heureFin</label>
          <ngb-timepicker formControlName="heureFin"
            [ngClass]="{'is-invalid': form.submitted && formGroup.get('heureFin').invalid}" class="form-control">
          </ngb-timepicker>
        </div>
      </div>

      <div class="form-section">
        <div class="mb-3">
          <label class="form-label" translate>page.commissions.edit.salle</label>
          <select formControlName="salle" [ngClass]="{'is-invalid': form.submitted && formGroup.get('salle').invalid}" class="form-select">
            <option *ngFor="let salle of salles" [ngValue]="salle">{{salle.nom}}</option>
          </select>
        </div>

        <div class="mb-3">
          <label class="form-label" translate>page.commissions.edit.animateur</label>
          <select formControlName="animateur" [ngClass]="{'is-invalid': form.submitted && formGroup.get('animateur').invalid}" class="form-select">
            <option *ngFor="let animateur of animateurs" [ngValue]="animateur">{{animateur.prenom}} {{animateur.nom}}
            </option>
          </select>
        </div>
      </div>

      <div>
        <button style="position:relative;left:66%;margin:1em;" type="button" class="btn btn-primary"
          (click)="affecterEchantillons()" translate>page.commissions.edit.jurys.affecter-echantillons</button>
      </div>

<div formArrayName="jurys" cdkDropList (cdkDropListDropped)="moveJury($event)">
  <div  *ngFor="let juryForm of jurys; let juryIndex  = index"  cdkDrag>
    <div class="jury-dad-placeholder" *cdkDragPlaceholder></div>

    <div [formGroupName]="juryIndex" class="form-group form-jury">
      <div class="jury-header">

        <h3 class="jury-title">
          <fa-icon cdkDragHandle
                  icon="bars"
                  class="grab"
                  [ngClass]="{'disabled': jurys.length < 2}">
          </fa-icon>

          {{ 'page.commissions.edit.jurys.title' | translate }} {{ juryIndex + 1 }}

          <fa-icon icon="trash"
                   class="pointer"
                   [ngClass]="{'disabled': jurys.length < 2}"
                   (click)="deleteJury(juryIndex)"
                   (keydown.enter)="deleteJury(juryIndex)">
          </fa-icon>

          <nav class="jury-tabs inline" aria-label="Navigation jury">
            <button type="button" class="tab"
                    (click)="setSelectedList('cdcs')"
                    (keydown.enter)="setSelectedList('cdcs')"
                    [class.active]="selectedList==='cdcs'">
              Cahiers <span class="count">{{juryForm.get('cdcs').value.length}}</span>
            </button>

            <button type="button" class="tab"
                    (click)="setSelectedList('jures')"
                    (keydown.enter)="setSelectedList('jures')"
                    [class.active]="selectedList==='jures'">
              Jurés <span class="count">{{juryForm.get('jures').value.length}}</span>
            </button>

            <button type="button" class="tab"
                    (click)="setSelectedList('echantillons')"
                    (keydown.enter)="setSelectedList('echantillons')"
                    [class.active]="selectedList==='echantillons'">
              Échantillons <span class="count">{{juryForm.get('echantillons').value.length}}</span>
            </button>
          </nav>
        </h3>

      </div>


      <!-- Contenu: 1 seule liste selon selectedList -->
      <div cdkDropListGroup  class="jury-tab-content">

        <ng-container *ngIf="selectedList==='cdcs'">
          <!-- TON BLOC CdC (inchangé) -->
          <div class="list-cdcs jury-liste"
               [ngClass]="{'is-invalid': form.submitted && juryForm.get('cdcs').invalid}">
            <h4 class="jury-liste-title">
              <span translate>page.commissions.edit.jurys.cdcs</span>
              <span> ({{juryForm.get('cdcs').value.length}})</span>
              <fa-icon icon="plus" (click)="addCdc(juryIndex)" (keydown.enter)="addCdc(juryIndex)"></fa-icon>
            </h4>

            <div cdkDropList
                  #cdcDrop="cdkDropList"
                  [id]="'cdcs-' + juryIndex"
                  [cdkDropListData]="getCdcsFA(juryForm)"
                  [cdkDropListEnterPredicate]="canDropCdc"
                  (cdkDropListDropped)="moveCdc($event)">

            <div class="ech-empty" *ngIf="getCdcsFA(juryForm).length === 0">
                  Dépose ici
            </div>

            <div *ngFor="let cdc of getCdcsFA(juryForm).controls"
                cdkDrag
                class="jury-liste-item cdc-item"
                [cdkDragData]="cdc">

              <div class="listes-dad-placeholder" *cdkDragPlaceholder></div>

              <fa-icon cdkDragHandle icon="bars" class="grab"></fa-icon>

              <span class="cdc-label">{{ cdc.value.libelle }}</span>

              <div class="cdc-actions">
                <fa-icon icon="trash"
                         (click)="removeCdc(juryIndex, cdc.value)"
                         (keydown.enter)="removeCdc(juryIndex, cdc.value)"
                         class="pointer jury-liste-delete">
                </fa-icon>
              </div>
            </div>
          </div>
          </div>
        </ng-container>

        <ng-container *ngIf="selectedList==='jures'">
            <div class="list-jures jury-liste"
                [ngClass]="{'is-invalid': form.submitted && juryForm.get('jures').invalid}">

              <h4 class="jury-liste-title">
                <span translate>page.commissions.edit.jurys.jures</span>
                <span> ({{juryForm.get('jures').value.length}})</span>
                <fa-icon icon="plus" (click)="addJure(juryIndex)" (keydown.enter)="addJure(juryIndex)"></fa-icon>
              </h4>

              <div cdkDropList
                  #jureDrop="cdkDropList"
                  [id]="'jures-' + juryIndex"
                  [cdkDropListData]="getJuresFA(juryForm)"
                  [cdkDropListEnterPredicate]="canDropJure"
                  (cdkDropListDropped)="moveJure($event)">


                <div class="ech-empty" *ngIf="getJuresFA(juryForm).length === 0">
                  Dépose ici
                </div>


                <div *ngFor="let jure of getJuresFA(juryForm).controls"
                    cdkDrag
                    class="jury-liste-item jure-item"
                    [cdkDragData]="jure">

                  <div class="listes-dad-placeholder" *cdkDragPlaceholder></div>

                  <fa-icon cdkDragHandle icon="bars" class="grab"></fa-icon>

                  <div class="jure-content">
                    <div class="jure-main">
                      <span class="jure-name">{{jure.value?.jure?.nom || '-'}}</span>
                      <span class="jure-sep">-</span>
                      <span class="jure-college">{{jure.value?.college?.code || '-'}}</span>

                      <span class="jure-statut">
                        <ng-container *ngTemplateOutlet="statutJure; context: { jure: jure }">
                        </ng-container>
                      </span>
                    </div>
                  </div>

                  <div class="jure-actions">
                    <fa-icon icon="trash"
                             (click)="removeJure(juryIndex, jure.value)"
                             (keydown.enter)="removeJure(juryIndex, jure.value)"
                             class="pointer jury-liste-delete"></fa-icon>
                  </div>

                </div>
              </div>
            </div>
          </ng-container>

        <ng-container *ngIf="selectedList==='echantillons'">

          <div class="list-echantillons jury-liste"
              [ngClass]="{'is-invalid': form.submitted && juryForm.get('echantillons').invalid}">

            <div class="ech-header">
              <h4 class="jury-liste-title">
                <span translate>page.commissions.edit.jurys.echantillons</span>
                <span> ({{ getEchantillonsFA(juryForm).length }})</span>
                <fa-icon icon="plus" (click)="addEchantillons(juryIndex)" (keydown.enter)="addEchantillons(juryIndex)" ></fa-icon>
              </h4>

              <fa-icon icon="filter" class="pointer" (click)="filterEchantillons(getEchantillonsFA(juryForm).value)" (keydown.enter)="filterEchantillons(getEchantillonsFA(juryForm).value)"></fa-icon>
            </div>

            <!-- Header "table" -->
            <div class="ech-table ech-table-header">
              <div></div> <!-- drag -->
              <div>#</div>
              <div>Type</div>
              <div>Produit</div>
              <div>Millésime</div>
              <div>CVI - Raison Sociale</div>
              <div class="col-num">Volume</div>
              <div>Logement</div>
              <div>Expertise / Passage</div>
              <div></div> <!-- actions -->
            </div>

            <div
              cdkDropList class="ech-dropzone"
              #echDrop="cdkDropList"
              [id]="'echantillons-' + juryIndex"
              (cdkDropListDropped)="moveEchantillon($event)"
              [cdkDropListData]="getEchantillonsFA(juryForm)"
              >

              <div class="ech-empty" *ngIf="getEchantillonsFA(juryForm).length === 0">
                Dépose ici
              </div>

              <div *ngFor="let eCtrl of getEchantillonsFA(juryForm).controls"
                  cdkDrag
                  class="ech-table ech-row"
                  [cdkDragData]="eCtrl">

                <div class="ech-cell ech-drag">
                  <fa-icon cdkDragHandle icon="bars" class="grab"></fa-icon>
                </div>

                <div class="ech-cell ech-ano">
                  {{ eCtrl.value?.numeroAnonymat }}
                </div>

                <div class="ech-cell ech-type">
                  <span class="badge"
                        [class.badge-e]="!!eCtrl.value?.echantillon"
                        [class.badge-l]="!!eCtrl.value?.leurre">
                    {{ eCtrl.value?.echantillon ? 'E' : 'L' }}
                  </span>
                </div>

                <!-- Produit -->
                <div class="ech-cell ech-produit">
                  <ng-container *ngIf="eCtrl.value?.echantillon?.produit as p">
                    <div class="main" [title]="p.libelle">
                      {{ p.libelle }}
                    </div>
                  </ng-container>

                  <ng-container *ngIf="eCtrl.value?.leurre?.produit as p">
                    <div class="main" [title]="p.libelle">
                      {{ p.libelle }}
                    </div>
                  </ng-container>
                </div>

                <!-- Millésime -->
                <div class="ech-cell ech-millesime">
                  {{ eCtrl.value?.echantillon?.millesime
                    || eCtrl.value?.leurre?.millesime
                    || '-' }}
                </div>

                <!-- Détails -->
                <div class="ech-cell ech-details">
                  <ng-container *ngIf="eCtrl.value?.echantillon as ech">
                    <div class="sub">
                      {{ getCVI(ech) }} — {{ getRaisonSociale(ech) }}
                    </div>
                  </ng-container>

                  <ng-container *ngIf="eCtrl.value?.leurre as l">
                    <div class="sub">
                      {{ l.type?.libelle }}
                      <span *ngIf="l.defauts?.length">
                        —
                        <span *ngFor="let defaut of l.defauts; let isLast=last">
                          {{ defaut.libelle }}{{ isLast ? '' : ', ' }}
                        </span>
                      </span>
                    </div>
                  </ng-container>
                </div>

                <!-- Volume -->
                <div class="ech-cell col-num">
                  <ng-container *ngIf="eCtrl.value?.echantillon as ech">
                    {{ ech.volume }}
                  </ng-container>
                </div>

                <!-- Logement -->
                <div class="ech-cell ech-logement">
                  <ng-container *ngIf="eCtrl.value?.echantillon as ech">
                    {{ ech.logement }}
                  </ng-container>
                </div>

                <!-- Expertise / Passage -->
                <div class="ech-cell ech-exp-pass">
                  <ng-container *ngIf="eCtrl.value?.echantillon as ech">
                    <span class="pill">{{ ech.expertise }}</span>
                    <span class="pill">{{ ech.passage }}</span>
                  </ng-container>
                </div>

                <!-- Actions -->
                <div class="ech-cell ech-actions">
                  <fa-icon icon="trash"
                           (click)="removeEchantillon(juryIndex, eCtrl)"
                           (keydown.enter)="removeEchantillon(juryIndex, eCtrl)"
                           class="pointer jury-liste-delete"></fa-icon>
                </div>

              </div>
            </div>
          </div>
        </ng-container>

      </div>
    </div>
  </div>

</div>
      <div class="actions-bar">
        <button type="button" class="btn btn-primary" (click)="addJury()"
          translate>page.commissions.edit.ajouter_jury</button>
        <span style="flex:1"></span>
        <button type="button" class="btn btn-primary" (click)="enregistrer()" translate>label.enregistrer</button>
        <button type="submit"  style="position:relative;margin-left: 1em;" class="btn btn-primary" translate>label.fermer</button>
      </div>
    </form>

  </div>
  <div style="height:20vh"></div>
</div>

<ng-template #statutJure let-jure="jure">
  <div ngbDropdown class="dropdown statut-jure">
    <strong
      ngbDropdownToggle
      class="btn-sm dropdown-toggle pointer statut-jure-current"
      [ngClass]="jure?.value?.statut?.code"
    >
      <fa-icon [icon]="getStatutIcon(jure?.value?.statut?.code)"></fa-icon>
      {{ jure?.value?.statut?.libelle || 'Non défini' }}
    </strong>

    <div class="dropdown-menu" ngbDropdownMenu>
      <span
        *ngFor="let statut of statutsJure"
        class="dropdown-item pointer statut-jure-item"
        [ngClass]="statut.code"
        (click)="changeStatut(jure, statut, $event)"
        (keydown.enter)="changeStatut(jure, statut, $event)">
        <fa-icon [icon]="getStatutIcon(statut.code)"></fa-icon>
        {{ statut.libelle }}
      </span>
    </div>
  </div>
</ng-template>
